import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, CircularProgress, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import AutoZeroForm from "./Form";
import { SETTING_TABLE_NAME } from "Constants/settingsTableName";
import { useSettingsUI } from "../../../hooks/useReduxSelectors";
import { useMsal } from "Auth/msal-context";
import { useKeyboard } from "../../../hooks/KeyboardContext";
import useSettings from "../../../hooks/useSettings";

const AutoZeroSettings = () => {
  const { t } = useTranslation("common");
  const { isAuthorized, isEdge } = useMsal();
  const { registerInput } = useKeyboard();

  const settingsUI = useSettingsUI();

  const { formState, updateField, loading, error, fetchSettings, saveSettings } =
    useSettings(SETTING_TABLE_NAME.AUTOZERO_SETTINGS);

  const handleSave = () => {
    if (!formState) return;
    saveSettings({
      startHour: formState.startHour,
      startMinute: formState.startMinute,
      inUse: formState.inUse,
      purgeEnabled: formState.purgeEnabled,
      sampleLinePurgeEnabled: formState.sampleLinePurgeEnabled,
    });
  };

  const inputSelected = (e, name) => {
    registerInput(name, e.target.value, (v) => updateField(name, v));
  };

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>AutoZero</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {loading && <CircularProgress size={24} />}
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>{t("No Settings Found")}</Typography>
        )}
        {!loading && formState && (
          <AutoZeroForm
            autoZeroSettingsFormatted={formState}
            settingsUI={settingsUI}
            handleOnChange={(value, key) => updateField(key, value)}
            inputSelected={inputSelected}
            t={t}
          />
        )}
        {(isAuthorized || isEdge) && formState && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" size="small" onClick={handleSave}>{t("Save")}</Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default AutoZeroSettings;
